import { Component, OnInit, inject, ChangeDetectionStrategy, signal } from '@angular/core';
import { ConversionInfosClient, GetConversionInfo } from '../../generated-client/generated-client';
import { DatePipe, JsonPipe } from '@angular/common';

import { FileDownloadService } from '../../services/file-download.service';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatButton } from '@angular/material/button';

@Component({
  selector: 'da-conversion-info-detail',
  templateUrl: './conversion-info-detail.component.html',
  styleUrls: ['./conversion-info-detail.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatButton, JsonPipe, DatePipe]
})
export class ConversionInfoDetailComponent implements OnInit {
  private fileDownloadService = inject(FileDownloadService);
  private conversionInfosClient = inject(ConversionInfosClient);
  conversionInfo = inject<GetConversionInfo>(MAT_DIALOG_DATA);

  public conversionOptions = signal<unknown>(null);

  downloadFile() {
    this.fileDownloadService.downloadFile(this.conversionInfo.fileId);
  }

  ngOnInit() {
    if (this.conversionInfo.id) {
      this.conversionInfosClient.getConversionInfoOptions(this.conversionInfo.id).subscribe(options => {
        this.conversionOptions.set(options.conversionOptionsJson && JSON.parse(options.conversionOptionsJson));
      });
    }
  }
}
